// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IRedirect } from '@/models/redirects.model';

// Components
import { Modal, ModalSize } from '@/components';
import { CrossIcon, EditIcon } from '@/icons';
import { COLORS } from '@/theme';
import { Button } from '@/ui';
import { StyledActionButton, StyledTitleModal } from '../Styled';
import { StyledActionsWrap, StyledButtonsWrapper } from './TableActionsStyles';

// Helpers
import { useModal } from '@/hooks';

type TTableActions = {
  record: IRedirect;
  onEdit: (redirect: IRedirect) => void;
  onDelete: (redirect: IRedirect) => void;
};

const TableActions = ({ onDelete, onEdit, record }: TTableActions) => {
  const { t } = useTranslation(['redirects']);
  const { isOpened, openModal, closeModal } = useModal();
  const handleEdit = () => onEdit(record);
  const handleDelete = () => onDelete(record);

  return (
    <StyledActionsWrap>
      <StyledActionButton onClick={handleEdit} $color={COLORS.GREEN}>
        <EditIcon />
      </StyledActionButton>
      <StyledActionButton $color={COLORS.RED} onClick={openModal}>
        <CrossIcon />
      </StyledActionButton>
      <Modal visible={isOpened} onCancel={closeModal} size={ModalSize.LARGE}>
        <StyledTitleModal>{t('redirect_delete_title')}</StyledTitleModal>
        <StyledButtonsWrapper>
          <Button onClick={closeModal} type="primary">
            {t('redirect_delete_cancel')}
          </Button>
          <Button onClick={handleDelete} type="text">
            {t('redirect_delete_ok')}
          </Button>
        </StyledButtonsWrapper>
      </Modal>
    </StyledActionsWrap>
  );
};

export default TableActions;
